import { assign } from 'lodash-es';
import { bindActionCreators } from 'redux';
import { setProject, setPartialProject, loadProject, setCommentCount, showCommentNotification, hideCommentNotification, enterAnnotationMode, leaveAnnotationMode, cancelCurrentAnnotation, addAnnotation, scrollToAnnotation, clearAnnotations, hideComments, highlightAnnotation, unhighlightAnnotation, makeAnnotationMoveable, markAnnotationSaved, annotationCommentUpdated, updateAnnotation, removeAnnotation, hideGrid, showHome, pauseReplay, startReplay, seekReplay, startRecording, stopRecording, setShowTouchIndicators, changeDeviceDetection, } from '../actionCreators';
import { isInAnnotationMode } from '../selectors/annotation';
import { getCurrentScreen } from '../selectors/screen';
// This is more verbose than something like lodash.pick,
// but eslint-plugin-import will prevent issues with
// misspelled / non-existent import names
var publicActionCreators = {
    setProject: setProject,
    setPartialProject: setPartialProject,
    loadProject: loadProject,
    setCommentCount: setCommentCount,
    showCommentNotification: showCommentNotification,
    hideCommentNotification: hideCommentNotification,
    enterAnnotationMode: enterAnnotationMode,
    leaveAnnotationMode: leaveAnnotationMode,
    cancelCurrentAnnotation: cancelCurrentAnnotation,
    addAnnotation: addAnnotation,
    scrollToAnnotation: scrollToAnnotation,
    clearAnnotations: clearAnnotations,
    hideComments: hideComments,
    highlightAnnotation: highlightAnnotation,
    unhighlightAnnotation: unhighlightAnnotation,
    makeAnnotationMoveable: makeAnnotationMoveable,
    markAnnotationSaved: markAnnotationSaved,
    annotationCommentUpdated: annotationCommentUpdated,
    updateAnnotation: updateAnnotation,
    removeAnnotation: removeAnnotation,
    closeGridNavigation: hideGrid,
    showHome: showHome,
    pauseReplay: pauseReplay,
    startReplay: startReplay,
    seekReplay: seekReplay,
    startRecording: startRecording,
    stopRecording: stopRecording,
};
export default function addPublicAPIs(instance, store) {
    assign(instance, bindActionCreators(publicActionCreators, store.dispatch), {
        setCommentMention: function () {
            // TODO Move to action creators
        },
        isInAnnotationMode: function () {
            return isInAnnotationMode(store.getState());
        },
        getCurrentScreen: function () {
            return getCurrentScreen(store.getState());
        },
        getConfig: function () {
            return store.getState().project.config.origProjectConfig;
        },
        enableTouchIndicators: function () {
            store.dispatch(setShowTouchIndicators(true));
        },
        disableTouchIndicators: function () {
            store.dispatch(setShowTouchIndicators(false));
        },
        setIsIpad: function () {
            store.dispatch(changeDeviceDetection({
                isIPad: true,
                isIOS: true,
                isMobile: true,
                hasTouch: true,
            }));
        },
        setIsIphone: function () {
            store.dispatch(changeDeviceDetection({
                isIOS: true,
                isIPhone: true,
                isMobile: true,
                hasTouch: true,
            }));
        },
    });
}
